<template>
  <a
    class="bg-gray-100 p-4 w-full flex flex-row items-center cursor-pointer"
    :href="causer_url"
  >
    <div class="icon bg-gray-100 rounded-lg border border-gray-400 p-3">
      <component
        :if="causerIcon"
        :is="causerIcon"
      ></component>
    </div>
    <div class="feed-details font-normal flex flex-row justify-between w-full">
      <div class="feed-topic flex flex-col px-3 justify-center">
        <span
          v-if="causer_name"
          class="block text-sm font-semibold flex-initial truncate leading-snug mb-1"
          :class="[textColor]"
          :title="title"
        >
          {{ causer_name }}
          <small class="block">{{ title }} </small>
        </span>
        <span
          v-else
          class="block text-sm font-semibold flex-initial truncate"
          :class="[textColor]"
          :title="title"
        >
          {{ title }}
        </span>

        <span
          v-if="datetime"
          class="text-xs text-gray-700"
        >
          {{ _date(datetime) }}
        </span>
      </div>
      <div
        v-if="datetime"
        class="feed-meta text-right pr-3"
      >
        <div class="text-xs text-gray-700">
          {{ _time(datetime) }}
        </div>
        <div class="text-xs text-gray-700">
          {{ _timeAgo(datetime) }}
        </div>
        <div
          v-if="source"
          class="text-xs text-gray-700"
        >
          {{ source }}
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import _date from '@/Filters/Date'
import _datetime from '@/Filters/DateTime'
import _time from '@/Filters/Time'
import _timeAgo from '@/Filters/TimeAgo'
import CustomerIcon from '@/Components/Icons/ActivityCustomerIcon.vue'
import ProductIcon from '@/Components/Icons/ActivityProductIcon.vue'
import LocationIcon from '@/Components/Icons/ActivityLocationIcon.vue'
import OrderIcon from '@/Components/Icons/ActivityOrderIcon.vue'

export default {
  components: {
    CustomerIcon,
    ProductIcon,
    LocationIcon,
    OrderIcon
  },

  props: {
    title: {
      type: String,
      default: 'title'
    },
    causer: {
      type: String,
      default: null
    },
    causer_name: {
      type: String,
      default: null
    },
    causer_url: {
      type: String,
      default: null
    },
    source: {
      type: String,
      default: null
    },
    datetime: {
      type: String,
      default: null
    },
    style: {
      type: String,
      default: 'success',
      validator(value) {
        return ['success', 'error', 'info'].includes(value)
      }
    }
  },

  computed: {
    causerIcon() {
      console.log(this.causer)
      switch (this.causer) {
        case 'Company':
          return 'CustomerIcon'
        case 'Locations':
          return 'LocationIcon'
        case 'Location':
          return 'LocationIcon'
        case 'Products':
          return 'ProductIcon'
        case 'Product':
          return 'ProductIcon'
        case 'Customers':
          return 'CustomerIcon'
        case 'Customer':
          return 'CustomerIcon'
        case 'Orders':
          return 'OrderIcon'
        case 'Order':
          return 'OrderIcon'
        default:
          return 'ProductIcon'
      }
    },

    textColor() {
      switch (this.style) {
        case 'info':
          return 'text-gray-600'
        case 'error':
          return 'text-red-600'
        case 'success':
        default:
          return 'text-blue-600'
      }
    }
  },

  methods: {
    _date,
    _datetime,
    _timeAgo,
    _time
  }
}
</script>
